const style = ({ theme }) => ({
    margin: 0
})

export default style
